import { EntityStatusOptions } from '../entityStatus';
import { FileListing, FileSummary } from './file';
import { StockItemListing } from './item';

export class StockItemFile {
    stockItem: StockItemListing;
    file: FileSummary;
    fileid: number;
    stockItemId: number;
    stockItemFileisPrimary: boolean;
    filename: string;
    status: EntityStatusOptions

    constructor(){
      this.stockItem = null;
      this.file = null;
      this.fileid = 0;
      this.stockItemId = 0;
      this.stockItemFileisPrimary = false;
      this.filename = '';
      this.status = EntityStatusOptions.Active;
    }
}
